import React from "react";
import { List, Tag, Empty } from "antd";
import { AirplaneOutlined } from "../../../../components/icons/SvgIcons";
import WidgetWrapper from "../../components/WidgetWrapper";
import { useLoadList } from "../../../../hooks";
import { flightOperationFlightService } from "../../../../api/enhancedApi";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const FleetStatusWidget = () => {
    const { data, isLoading, refetch } = useLoadList("fleet_status_widget", flightOperationFlightService.getFlightOperations, {
        page: 1,
        page_size: 20,
        status: "DEPARTED", // Only airborne
    });

    return (
        <WidgetWrapper title="空中机队 (Airborne)" loading={isLoading} onRefresh={refetch}>
            {data?.items?.length > 0 ? (
                <List
                    dataSource={data.items}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={<AirplaneOutlined style={{ fontSize: "24px", color: "var(--accent-primary)" }} />}
                                title={
                                    <span>
                                        {item.aircraft_reg}{" "}
                                        <Tag color="blue" style={{ background: "rgba(24, 144, 255, 0.2)", color: "#1890ff", border: "none" }}>
                                            {item.flight_number}
                                        </Tag>
                                    </span>
                                }
                                description={<span style={{ color: "var(--text-secondary)" }}>{`${item.departure_airport} -> ${item.arrival_airport} (ETA UTC: ${item.eta ? dayjs.utc(item.eta).format("HH:mm") : "--:--"})`}</span>}
                            />
                        </List.Item>
                    )}
                />
            ) : (
                <Empty description="当前无空中飞机" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </WidgetWrapper>
    );
};

export default FleetStatusWidget;
